import { useCallback, useRef } from 'react'
import { useUpdateRundownCue } from '../../entities/rundown/index.js'
import {
  SavingIndicator,
  SavingIndicatorState,
} from '../../shared/ui/saving-indicator/index.js'
import { useCueContext } from '../../features/cue/index.js'
import CueItemTitle from './cue-item-title'
import CueItemSubtitle from './cue-item-subtitle'
import { getCueAtom } from '../../store/rundown.store.ts'
import { useAtomValue } from 'jotai'

function CueItemHeader({ rundownId, readonly = false }) {
  const { cueId } = useCueContext()
  const getCue = useAtomValue(getCueAtom)
  const cue = getCue(cueId)

  const {
    mutate: updateRundownCue,
    isPending,
    isSuccess,
    isError,
  } = useUpdateRundownCue()

  // Refs for managing focus and key handling on the title/subtitle ContentEditable
  const titleRef = useRef(null)
  const subtitleRef = useRef(null)

  // Wrapper function to handle save states and errors
  const handleUpdateCue = useCallback(
    (updates) => {
      updateRundownCue({
        rundownId: rundownId,
        cueId,
        payload: updates,
      })
    },
    [cueId, rundownId, updateRundownCue],
  )

  return (
    <div className="h-full flex relative">
      <div className="sticky top-[107px] px-3 pt-8 pb-2 flex flex-col w-full h-min">
        <CueItemTitle
          inputRef={titleRef}
          subtitleRef={subtitleRef}
          value={cue.title}
          onChange={(title) => handleUpdateCue({ title })}
          disabled={readonly || cue.settings?.preventEdits}
          readonly={readonly}
        />
        <CueItemSubtitle
          inputRef={subtitleRef}
          titleRef={titleRef}
          className="text-sm text-white/60"
          value={cue.subtitle}
          onChange={(subtitle) => handleUpdateCue({ subtitle })}
          disabled={readonly || cue.settings?.preventEdits}
          readonly={readonly}
        />
      </div>

      <SavingIndicator
        states={{
          [SavingIndicatorState.SAVING]: isPending,
          [SavingIndicatorState.ERROR]: isError,
          [SavingIndicatorState.SAVED]: isSuccess,
        }}
        className="absolute z-30 bottom-1 right-1"
      />
    </div>
  )
}

export default CueItemHeader